import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import RainEffect from '../components/RainEffect'
import styles from './NotFound.module.scss'

const NotFoundPage = () => {
  const navigate = useNavigate()

  const handleGoHome = () => {
    navigate('/')
  }

  return (
    <div className={styles['not-found-page']}>
      <RainEffect intensity={300} />
      <div className={styles['error-content']}>
        <div className={styles['error-box']}>
          <FontAwesomeIcon icon='exclamation-triangle' size='3x' className={styles['text-warning']} />
          <h1 className={styles['error-code']}>404</h1>
          <h2 className={styles['error-title']}>Page Not Found</h2>
          <p className={styles['error-message']}>
            Sorry, the page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>
          <button
            className={styles['home-button']}
            onClick={handleGoHome}
          >
            <FontAwesomeIcon icon='home' className={styles['button-icon']} />
            Go to Home
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
